import { VolverService } from '../../../providers/volver.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { BotonTipo } from '../../../components/boton/boton';

import { Location } from '@angular/common';
import { CrearClasificacionClientesDialogComponent } from './crear-clasificacion-clientes-dialog/crear-clasificacion-datos-dialog.component';
import { CursoService } from '../../../providers/cursos.service';
import { ClasificacionClientesService } from '../../../providers/clasificacion-clientes.service';
@Component({
  selector: 'app-crear-clasificacion-clientes',
  templateUrl: './crear-clasificacion-clientes.component.html',
  styleUrls: ['./crear-clasificacion-clientes.component.scss']
})
export class CrearClasificacionClientesComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = 'below';
  @Output() onCerrado = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    // private propuestaSv: PropuestasService,
    // private usuarioSv: UsuarioService,
    private volverService:VolverService,
    private location: Location,
    private clientesSv: ClasificacionClientesService,
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
  }

  openDialog(): void {
    let dialogCrear = this.dialog.open(CrearClasificacionClientesDialogComponent, {
      disableClose: true
    });

    dialogCrear.afterClosed().subscribe(cursoCreado => {
      if(cursoCreado){
        this.clientesSv.crearClasificacion(cursoCreado.id, 1, cursoCreado.descripcion).subscribe(
          respuesta => {
            if(respuesta.estado == 1){
              this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
              this.onCerrado.emit();
            }else{
              this.snackBar.open(respuesta.mensaje, '', { duration: 2750 });
              return;
            }
          }, () => {

          }
        )
      }
    });
  }

  volver() {
    // avisarle al sistema que hicieron click en volver
    VolverService.click_en_volver = true;
    // indicar que hicieron click en volver
    this.location.back();
  }
}
